import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import { deleteOrigin, getOrigin } from "../../../actions/origin/origin";
import OriginListComponent from "../../../components/Definition/Origin/OriginListComponent";

export default function OriginScreen() {
    const [origin, setOrigin] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();


    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getOrigin(params.toString());
                setLoading(false);
                setOrigin(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <OriginListComponent lists={origin} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید مبدا حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteOrigin(id);
                    if (response.status === "success") {
                        toast.success("مبدا حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف مبدا");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
